import { FilmQuotaService } from '@/scripts/services/filmQuotaService';
import { manifest } from './filmQuotaLoginFlowService/manifest';
import { checkServiceRequirement } from './filmQuotaLoginFlowService/environmentVerifier';
import { registerListener } from './filmQuotaLoginFlowService/tracker';

let fqs = null as null | FilmQuotaService;
export const filmQuotaLoginFlow = {
  get service(): FilmQuotaService | null {
    return fqs;
  },

  async init(): Promise<void> {
    if (fqs != null) return;

    if (!await checkServiceRequirement()) return;

    fqs = new FilmQuotaService();

    registerListener(fqs);

    await fqs.initialize(manifest);
  },
};
